import { countries } from "../data/languages";

export const getCurrentCountryCode = () => {
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    const country_codes = countries.map(country => country.code);
    if (country_codes && pathname) {
      const elements = pathname.split('/').filter(element => element);
      if (elements && elements.length > 1) {
        const country_code_index = elements[0] === 'support-center' ? 2 : 1;
        return country_codes.includes(elements[country_code_index]) ? elements[country_code_index] : "us";
      }
    }
  }

  return "us";
}
